// generated from 1 samples

import { z } from "zod";

export const behaviorBaseTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::BehaviorBase"),
});
